export const MAX_FILE_SIZE_IN_MB = 15;
export const patientSex = ['Select', 'Male', 'Female', 'Other'];

export enum MultimediaType {
  ProfilePicture = 'ProfilePicture',
  Identification = 'Identification',
  InsuranceCard = 'InsuranceCard',
  CreditCard = 'CreditCard',
  VisitNoteImage = 'VisitNoteImage',
  MRI = 'MRI',
  Xray = 'Xray',
  CTScan = 'CTScan',
  Ultrasound = 'Ultrasound',
  LabReport = 'LabReport',
  EMG = 'EMG',
  OperativeReport = 'OperativeReport',
  Pathology = 'Pathology',
  PersonalInjuryPaperwork = 'PersonalInjuryPaperwork',
  WorkersCompensationPaperwork = 'WorkersCompensationPaperwork',
  CarAccidentPaperwork = 'CarAccidentPaperwork',
  Referral = 'Referral',
  MedicalNotes = 'MedicalNotes',
  ConsentForms = 'ConsentForms',
  OtherProviderNote = 'OtherProviderNote',
  MedicalRecords = 'MedicalRecords',
  FinalizedVisitNote = 'FinalizedVisitNote',
  RadiologyImages = 'RadiologyImages',
  EOB = 'EOBDoc',
  ClaimAttachment = 'ClaimAttachment',
  Other = 'Other',
}

export enum MediaOriginatorType {
    Org = 'Org',
    Patient = 'Patient',
    Billing = 'Billing',
  }
